import * as React from 'react';
import SupportTicket from '../../../models/supportTicket';
import { Modal } from '@material-ui/core';
import * as styles from './modal.module.scss';
import DisabledInput from '../../common/disabled-input';
import CommentForm from './comment-form';
import CommentSection from './comment-section';
import Scrollbars from 'react-custom-scrollbars';
import MaterialIcon from '@material/react-material-icon';
import AttachedFiles from './attached-files';

interface Props {
  ticket: SupportTicket;
  isOpen: boolean;
  onClose: (open: boolean, option?: any) => void;
}

/**
 * ViewTicketModal
 * @function ViewTicketModal - Modal that shows the details of an individual ticket
 */
const ViewTicketModal = ({ ticket, isOpen, onClose }: Props) => {
  return (
    <Modal
      className={styles.ticketModal}
      open={isOpen}
      onClose={(isOpen: boolean, option?: any) => onClose(!isOpen, option)}
    >
      {ticket ? (
        <div className={styles.container}>
          <MaterialIcon icon="close" onClick={() => onClose(!isOpen, null)} />
          <div className={styles.header}>
            <DisabledInput
              value={ticket.summary}
              label={ticket.issueName}
              disabled={true}
              isheader="true"
              InputProps={{ disableUnderline: true }}
            />
            <div className={styles.status}>
              <span className={styles.label}>Status:</span>
              <span>{ticket.status}</span>
            </div>
          </div>
          <div className={styles.center}>
            <Scrollbars>
              <div className={styles.details}>
                <DisabledInput
                  value={ticket.issueType}
                  label="Type"
                  disabled={true}
                  InputProps={{ disableUnderline: true }}
                />
                <DisabledInput
                  value={ticket.priority}
                  label="Priority"
                  disabled={true}
                  InputProps={{ disableUnderline: true }}
                />
                <DisabledInput
                  value={ticket.organizationName}
                  label="Service Desk Organization"
                  disabled={true}
                  InputProps={{ disableUnderline: true }}
                />
                <DisabledInput
                  value={ticket.reporter}
                  label="Reporter"
                  disabled={true}
                  InputProps={{ disableUnderline: true }}
                />
                <DisabledInput
                  value={ticket.summary}
                  label="Summary"
                  disabled={true}
                  multiline={true}
                  InputProps={{ disableUnderline: true }}
                />
                <DisabledInput
                  value={ticket.resolution}
                  label="Resolution"
                  disabled={true}
                  InputProps={{ disableUnderline: true }}
                />
              </div>
              <div className={styles.filesSection}>
                <h6>Attachments</h6>
                {ticket.attachments && ticket.attachments.length > 0 ? (
                  <AttachedFiles files={ticket.attachments} />
                ) : (
                  <span className={styles.noResults}>No attachments present</span>
                )}
                {ticket.description && (
                  <DisabledInput
                    value={ticket.description}
                    label="Description"
                    disabled={true}
                    InputProps={{ disableUnderline: true }}
                  />
                )}
              </div>
              <CommentSection comments={ticket.comments} />
            </Scrollbars>
          </div>
          <div className={styles.commentForm}>
            <CommentForm ticket={ticket} />
          </div>
        </div>
      ) : (
        <div />
      )}
    </Modal>
  );
};

export default ViewTicketModal;
